// ─── Garde (calendrier de résidence) — données PARTAGÉES MoPCal ───
// La garde d'un jour vit sur calendriers/{calId}/jours/{YYYY-MM-DD}.garde
// (= 'parent1' | 'parent2'). Même structure que MoPCal → partagé.
// Ne concerne que les calendriers de type « enfant » (co-parentalité).
import { db, PALETTE_DEFAUT } from '@mop/core';
import { collection, doc, onSnapshot, setDoc, getDoc, writeBatch } from 'firebase/firestore';

// Couleurs de garde par défaut (parent1 = rose, parent2 = bleu). L'utilisateur
// peut les changer par calendrier (couleurParent1 / couleurParent2 sur le doc).
// Anneau « échange / exception de garde » (ambre) — partagé écran + hooks.
export const COL_EXC = '#E8A33D';
export const GARDE_COL_DEFAUT = { parent1: '#FF6B8A', parent2: '#4D8AF0' };
// Palette proposée dans la configuration (choix utilisateur).
export const PALETTE_GARDE = PALETTE_DEFAUT;   // palette partagée (Core)

export function ecouterGarde(calId, callback) {
  if (!calId) { callback({}); return () => {}; }
  return onSnapshot(collection(db, 'calendriers', calId, 'jours'),
    snap => { const m = {}; snap.forEach(d => { const g = d.data().garde; if (g) m[d.id] = g; }); callback(m); },
    () => callback({}));
}

export async function setGardeJour(calId, dk, garde) {
  await setDoc(doc(db, 'calendriers', calId, 'jours', dk), { garde: garde || null }, { merge: true });
}

// Efface (supprime) une liste de surcharges de garde par jour → ces jours
// retombent sur le calcul (rythme / vacances). Par lots pour ne pas saturer.
export async function effacerGardeJours(calId, dks) {
  if (!calId || !dks || !dks.length) return;
  const arr = [...new Set(dks)];
  for (let i = 0; i < arr.length; i += 400) {
    const batch = writeBatch(db);
    for (const dk of arr.slice(i, i + 400)) batch.delete(doc(db, 'calendriers', calId, 'jours', dk));
    await batch.commit();
  }
}

// Libellés des parents (depuis le doc calendrier ; repli générique).
export async function lireParents(calId) {
  try {
    const snap = await getDoc(doc(db, 'calendriers', calId));
    const f = snap.exists() ? snap.data() : {};
    return {
      parent1: { uid: f.parent1Uid || f.creePar || null, nom: f.nomParent1 || 'Parent 1', email: f.emailParent1 || null },
      parent2: { uid: f.parent2Uid || f.parent2 || null, nom: f.nomParent2 || 'Parent 2', email: f.emailParent2 || null },
      // Couleurs de garde choisies par l'utilisateur (repli sur les couleurs par défaut).
      couleur1: f.couleurParent1 || GARDE_COL_DEFAUT.parent1,
      couleur2: f.couleurParent2 || GARDE_COL_DEFAUT.parent2,
      demandesActives: f.demandesActives !== false,   // défaut : demandes activées
      estEnfant: (f.type === 'coparentalite' || f.type === 'enfant'),
    };
  } catch { return { parent1: { nom: 'Parent 1' }, parent2: { nom: 'Parent 2' }, couleur1: GARDE_COL_DEFAUT.parent1, couleur2: GARDE_COL_DEFAUT.parent2, demandesActives: true, estEnfant: false }; }
}

// Écrit la config des parents + l'activation des demandes de changement de garde.
export async function definirParents(calId, p) {
  await setDoc(doc(db, 'calendriers', calId), {
    nomParent1: (p?.nomParent1 || '').trim() || 'Parent 1',
    parent1Uid: p?.parent1Uid || null,
    emailParent1: p?.emailParent1 || null,
    nomParent2: (p?.nomParent2 || '').trim() || 'Parent 2',
    parent2Uid: p?.parent2Uid || null,
    emailParent2: p?.emailParent2 || null,
    couleurParent1: p?.couleurParent1 || GARDE_COL_DEFAUT.parent1,
    couleurParent2: p?.couleurParent2 || GARDE_COL_DEFAUT.parent2,
    demandesActives: p?.demandesActives !== false,
  }, { merge: true });
}
